export const HIGHLIGHTED_REVIEW_IDS: string[] = [];

export const HIGHLIGHT_DISPLAY_PRIORITIES: Record<string, number> = {};

export const HIGHLIGHT_FALLBACK_STRATEGY: 'verified-recent' | 'top-rated' = 'verified-recent';

export const HOME_CAROUSEL_MAX = 21;
